import { useEffect, useMemo, useState } from 'react';
import { supabase } from '@/lib/supabase';

// Settings, Find a suburb (Gary, 16 Oct): who covers a suburb, from head office's one suburb
// list (Portal, WhatsApp settings, Suburbs), the same list Dr C and the website route by.
// Read only; other spellings are matched too.

interface SuburbRow { name: string; town: string | null; other_spellings: string[]; territories: { name: string } | null }

const fold = (s: string) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();

export function FindSuburb({ live }: { live: boolean }) {
  const [list, setList] = useState<SuburbRow[] | null>(null);
  const [term, setTerm] = useState('');

  useEffect(() => {
    if (!live) return;
    void supabase.from('suburbs').select('name, town, other_spellings, territories(name)').eq('active', true).order('name').limit(5000)
      .then(({ data }) => setList((data ?? []) as unknown as SuburbRow[]));
  }, [live]);

  const found = useMemo(() => {
    const q = fold(term);
    if (!list || q.length < 2) return [];
    return list.filter((s) => [s.name, s.town ?? '', ...s.other_spellings].some((x) => fold(x).includes(q))).slice(0, 20);
  }, [list, term]);

  return (
    <>
      <div className="chats-pad">
        <input
          id="find-suburb"
          className="chats-input"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder="Type a suburb"
          aria-label="Find a suburb"
          disabled={!live}
        />
      </div>
      {term.trim().length >= 2 && (
        <div className="chats-group">
          {list === null && <div className="chats-set"><div className="chats-set-main"><small>Loading...</small></div></div>}
          {list !== null && found.length === 0 && (
            <div className="chats-set"><div className="chats-set-main">Not on the list<small>Nobody covers it yet. Head office adds suburbs in the Portal.</small></div></div>
          )}
          {found.map((s) => (
            <div key={`${s.name}-${s.town ?? ''}`} className="chats-set">
              <div className="chats-set-main">
                {s.name}{s.town ? `, ${s.town}` : ''}
                <small>{(s.territories?.name ?? 'Territory switched off').replace(/^CleanMyBed\s+/i, '')}</small>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
